import React from "react";
import { Alert, Box, Grid, Paper, Typography } from "@mui/material/";
import { strings } from "../../../common/i18n";
import { useSharedAsset } from "../../../common/hooks";
import ShareIcon from "@mui/icons-material/Share";

type Props = {
    LeftComponent: React.ReactNode,
    RightComponent: React.ReactNode,
    SideComponent: React.ReactNode
};

/**
 * Audit/Alt Asset Layout Component
 */
export default ({ LeftComponent, RightComponent, ActionComponent }: Props) => {
    const isSharedAsset = useSharedAsset();
    return (
        <>
            <Grid container direction="row">
                <Grid item xs={6}>
                    {LeftComponent}
                </Grid>
                <Grid item xs={6}>
                    {isSharedAsset ? (
                        <Paper elevation={3}>
                            <Alert icon={<ShareIcon />} severity="info">
                                {strings("messages.validatedVisibility")}
                            </Alert>
                        </Paper>
                    ) : null}
                    <Box
                        component="div"
                        style={{
                            height: "60vh",
                            overflow: "auto",
                            backgroundColor: isSharedAsset
                                ? "#e5f6fd"
                                : "transparent"
                        }}
                    >
                        {RightComponent}
                    </Box>
                    <Typography component="div">{ActionComponent}</Typography>
                </Grid>
            </Grid>
        </>
    );
};
